import React from 'react';
import WarningActionDialog from './WarningActionDialog';

interface ItemNameWarningDialogProps {
    show: boolean;
    onAccept: () => void;
    onCancel: () => void;
    orderItemName: string;
    barcodeItemName: string;
}

const ItemNameWarningDialog: React.FC<ItemNameWarningDialogProps> = ({
    show,
    onAccept,
    onCancel,
    orderItemName,
    barcodeItemName,
}) => {
    return (
        <WarningActionDialog
            id="ItemNameWarningModal"
            show={show}
            title="Warning"
            message="Ordered item name does not match with scanned barcode item name. Do you want to continue?"
            onAccept={onAccept}
            onCancel={onCancel}
        >
            <ul>
                <li>Ordered : <strong className="text-primary">{orderItemName}</strong> </li>
                <li>Scanned : <strong className="text-secondary">{barcodeItemName}</strong> </li>
            </ul>
        </WarningActionDialog>
    );
};

export default ItemNameWarningDialog;